// 嵌入碼的 brand_id → 版面用的 brand slug。palette 與 logo 都從這裡拿 slug，不各自解析。
// slug 對齊 openapi 的 Brand enum。
export const BRAND_SLUGS = ['news', 'health', 'cars', 'supertaste', 'woman'] as const
export type BrandSlug = (typeof BRAND_SLUGS)[number]

// 認不得的 brand_id 一律當 news（palette 與 logo 同一個 fallback）。
export const DEFAULT_BRAND: BrandSlug = 'news'

// 數字別名 1–5 是舊嵌入碼的寫法，widget 選擇繼續認得。
const ALIASES: Record<string, BrandSlug> = {
  news: 'news',
  health: 'health',
  cars: 'cars',
  supertaste: 'supertaste',
  woman: 'woman',
  1: 'woman',
  2: 'supertaste',
  3: 'health',
  4: 'news',
  5: 'cars',
}

// hasOwn（非直接索引）：host 可控的 brand_id 若是 'constructor' / 'toString'，直接索引會沿原型鏈取到 function。
export function resolveBrand(brandId: string): BrandSlug {
  return (Object.hasOwn(ALIASES, brandId) ? ALIASES[brandId] : undefined) ?? DEFAULT_BRAND
}

// header logo 是否顯示、顯示哪個 brand 的 logo 的唯一 owner。兩種情況回 null（不顯示）：空 brand
// id（preview 尚未選 IP 版位；判準與 survey-element.ts 的 no-config 收合共用同一個 falsy 字串
// 檢查），以及問卷的 does_show_logo 為 false（缺值視為顯示）。其餘走 resolveBrand（認不得仍退回
// news）。palette 不經過這裡——resolveBrand 本身對空字串一樣回 news，色票維持預設。
export function resolveHeaderBrand(brandId: string, doesShowLogo: boolean = true): BrandSlug | null {
  return brandId && doesShowLogo !== false ? resolveBrand(brandId) : null
}
